import { Component, OnInit } from '@angular/core'
import { Router, NavigationEnd } from '@angular/router'
import { filter } from 'rxjs'
import { VERSION } from '@env/version'

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit{
  title = 'AppliCom'
  isHash = true
  version = VERSION
  connected = localStorage.getItem('token')
  public route: any = ''

  constructor(private _router: Router){
      this.route = this._router.url
  }

  ngOnInit(): void {
    this._router.events.pipe(
        filter(event => event instanceof NavigationEnd)
      ).subscribe(event => {
        this.connected = localStorage.getItem('token')
      })
  }
}
